<template>
  <modal name="user-pro-info">
    <button
      @click="hide('user-pro-info')"
      style="margin:5% 5%; cursor:pointer"
      class="pull-right"
    >
      <span class="mdi mdi-alpha-x-circle"></span>
    </button>
    <div style="margin-top:5%;" class="form-group col-8">
      <h4 style="color:black">{{ $t("attr.contactDetails") }}</h4>
    </div>
    <div class="form-group col-8" style="margin-bottom: 2%;">
      <label class="label-pro-info-bold">{{ $t("attr.companyName") }}: </label>
      <label v-if="store != undefined" class="label-pro-info">
        &nbsp; {{ store.name }}</label
      >
      <label v-else class="label-pro-info">
        &nbsp; {{ user.store[0].name }}</label
      >
    </div>
    <div class="form-group col-8" style="margin-bottom: 2%;">
      <label class="label-pro-info-bold">{{ $t("attr.lastname") }}: </label
      ><label class="label-pro-info"> &nbsp;{{ user.lastname }}</label>
    </div>
    <div class="form-group col-8" style="margin-bottom: 2%;">
      <label class="label-pro-info-bold">{{ $t("attr.firstname") }}: </label
      ><label class="label-pro-info"> &nbsp;{{ user.firstname }}</label>
    </div>
    <div class="form-group col-8" style="margin-bottom: 2%;">
      <label class="label-pro-info-bold">{{ $t("attr.address") }}: </label
      ><label class="label-pro-info"> &nbsp;{{ user.address }}</label>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
    },
    store: {
      type: Object,
    },
  },
  methods: {
    hide(modalName) {
      this.$modal.hide(modalName);
    },
  },
};
</script>
